import script from "./ListSettingsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListSettingsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ListSettingsModal.vue?vue&type=style&index=0&id=6c06ecc4&scoped=true&lang=css"
import "./ListSettingsModal.vue?vue&type=style&index=1&id=6c06ecc4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c06ecc4"]])

export default __exports__